import * as PaginationStyles from './Pagination.styles'

export { default as Pagination } from './Pagination'
export { default as CursorPagination } from './CursorPagination'
export { default as usePagination } from './Pagination.hooks'
export const StyledPagination = PaginationStyles
